import UserAuthenticationService from './UserAuthenticationService';
import { makeRequest } from 'js/services/Network';
import AnonymousId from 'js/services/AnonymousId';

class GoogleAuth extends UserAuthenticationService{
  isAlreadyInitialized = false;

  async isInitialized() {
    await this.loadScript();
    return new Promise((resolve, reject) => {
      window.gapi
        ? window.gapi.load('auth2', () => {
          let settings = {
            client_id: window.app.googleSignInClientId,
            scope: 'profile'
          };

          this.auth2 = window.gapi.auth2.init(settings);
          resolve(true);
        })
        : reject(false);
    });
  }

  async loadScript(){
    return new Promise((resolve, reject) => {
      (function(d, s, id) {
        let js,
          fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {
            return;
          }
          js = d.createElement(s);
          js.id = id;
          // js.src = 'https://accounts.google.com/gsi/client';
          js.src = 'https://apis.google.com/js/api:client.js';

          js.addEventListener('load', function() {
            resolve(js);
          }, false);

          js.addEventListener('error', function() {
            reject(js);
            console.error('was error');
          }, false);

          fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'google-jssdk');
    });
  }

  async attachSignin(element) {
    return new Promise((resolve, reject) => {
      // let rs = window.open('https://google.com', '_blank');
      this.auth2.attachClickHandler(element, {},
        (googleUser) => {
          const token = googleUser.getAuthResponse(true).access_token;
          resolve(token);
        }, (error) => {
          if(this.isSafari() && error.error === 'popup_blocked_by_browser'){
            reject('popup_blocked_by_browser');
          }else{
            console.log(JSON.stringify(error, undefined, 2));
          }
        });
        element.click();
    });
  }

  async loginReq() {
    if(!this.isAlreadyInitialized){
      await this.isInitialized();
    }
    this.isAlreadyInitialized = true;
    return this.attachSignin(document.getElementById('gSignInWrapper'));
  }

  /**
   * Trigger Google login
   *
   * @param scope
   * @param data
   * @returns Promise
   * @memberof GoogleAuth
   */
  async login(scope, data = {}) {
    this.token = await this.loginReq();

    return (await makeRequest('google-login', null, {
      google_token: this.token,

      anonymous_id: AnonymousId,
      token: (document.getElementsByName("token")[0])?document.getElementsByName("token")[0].value:null,
      ...data,
    })).data;
  }

  async loginDirect(token, { singleUseToken, mseller }) {
    return (await makeRequest('google-login', null, {
      google_token: token,
      anonymous_id: AnonymousId,
      single_use_token: singleUseToken,
      mseller: mseller,
      token: (document.getElementsByName("token")[0])?document.getElementsByName("token")[0].value:null,
    })).data;
  }

  isSafari(){
    return  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }
}

export default new GoogleAuth();
